// Generic, config-decoupled override: fields listed here render
// editable for a not-yet-persisted director row (`isNewDir`), regardless of what the per-org
// `dataToDisplay` config says. Scoped to director-CREATION only — never mutates the source
// config, and never touches the bureau's fetch/consent field-requirement set for an
// already-saved director. No bureau-name literal: adding a field or extending to a future
// bureau needs only a change here.
export const ADD_DIRECTOR_REQUIRED_FIELDS = ['pan'] as const;

export function getEffectiveDirectorFieldConfig(
    dataToDisplay: Record<string, { isEditable: boolean }> | undefined,
    isNewDir: boolean | undefined,
): Record<string, { isEditable: boolean }> {
    if (!isNewDir) return dataToDisplay ?? {}; // saved director → untouched (fetch gate unaffected)
    const effective = { ...(dataToDisplay ?? {}) }; // shallow copy — never mutate the source
    for (const field of ADD_DIRECTOR_REQUIRED_FIELDS) {
        effective[field] = { ...(effective[field] ?? {}), isEditable: true };
    }
    return effective;
}
